import { Row } from 'antd';
import { Divider as DividerAntd } from 'antd';
import { rgba } from 'polished';
import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const HeaderWrapper = styled.div`
  background-color: ${rgba(COLOR.IRON, 0.26)};
  margin: -90px;
  padding: 90px;
  padding-bottom: 0;
  margin-bottom: 0;
`;

export const HeaderActions = styled(Row)`
  font-weight: normal;
  line-height: 18px;
  font-size: 12px;
  color: ${COLOR.OUTER_SPACE};
  margin-top: 50px;
  margin-bottom: 40px;
  position: relative;
  align-items: center;
`;

export const Title = styled.h1`
  text-transform: uppercase;
  font-weight: bold;
  line-height: 22px;
  font-size: 18px;
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
`;

export const Overall = styled.span`
  margin-bottom: 50px;
  line-height: 15px;
  font-size: 12px;
  font-weight: bold;
`;

export const Divider = styled(DividerAntd)`
  margin: 5px 0;
`;
